import { useMenuStore } from 'vince-core/stores/menuStore';
import { Menu, SubHeader } from 'vince-core/types/menu';
import { ResourceType } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    store.addMenuItem('menus.workflows', '/workflows', 3, Menu.MAIN, undefined, 'pi pi-workflows', {
        app: VinceApp.FND,
        resource: ResourceType.WORKFLOW,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.workflowStatistics', '/workflow-statistics', 2, Menu.ADMINISTRATION, SubHeader.REPORTS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.WORKFLOW,
        resourceId: '*',
        action: '*'
    });
});
